/**
 * Admin vertical menu – { label, href, icon, permission }.
 * permission: required permission code (or null = show to all authenticated).
 * Icons from react-icons (Io* / Md*).
 */
import {
  IoStatsChartOutline,
  IoPricetagsOutline,
  IoShirtOutline,
  IoOptionsOutline,
  IoReceiptOutline,
  IoGiftOutline,
  IoCalendarOutline,
  IoCloudUploadOutline,
  IoDocumentTextOutline,
  IoImagesOutline,
  IoPeopleOutline,
  IoKeyOutline,
  IoListOutline,
  IoPersonCircleOutline,
  IoPersonOutline,
  IoMenuOutline,
  IoFingerPrintOutline,
  IoCartOutline,
  IoServerOutline,
  IoArrowUpOutline,
  IoArrowDownOutline,
  IoShirtSharp,
  IoWarningOutline,
  IoGridOutline,
  IoNotificationsOutline,
  IoAlertCircleOutline,
  IoBookOutline,
  IoGlobeOutline,
  IoMegaphoneOutline,
  IoCheckmarkDoneOutline,
} from 'react-icons/io5';

const verticalMenuData = [
  { label: 'Dashboard', href: '/admin/dashboard', icon: IoStatsChartOutline, permission: null },
  { label: 'Categories', href: '/admin/categories', icon: IoPricetagsOutline, permission: 'manage_categories' },
  {
    group: true,
    label: 'Catalog',
    icon: IoShirtOutline,
    children: [
      { label: 'All products', href: '/admin/products', icon: IoShirtOutline, permission: 'manage_products', end: true },
      { label: 'Need attention', href: '/admin/products/needs-attention', icon: IoAlertCircleOutline, permission: 'manage_products' },
      { label: 'Variations', href: '/admin/variations', icon: IoOptionsOutline, permission: 'manage_products' },
    ],
  },
  { label: 'Orders', href: '/admin/orders', icon: IoReceiptOutline, permission: 'manage_orders' },
  { label: 'Tax and Shipping', href: '/admin/settings/checkout', icon: IoCartOutline, permission: 'manage_orders' },
  {
    group: true,
    label: 'SEO',
    icon: IoGlobeOutline,
    children: [
      { label: 'Global SEO', href: '/admin/settings/seo', icon: IoGlobeOutline, permission: 'manage_pages' },
      { label: 'Product SEO Checker', href: '/admin/settings/seo-checker', icon: IoCheckmarkDoneOutline, permission: 'manage_products' },
    ],
  },
  { label: 'Announcement Bar', href: '/admin/settings/announcement', icon: IoMegaphoneOutline, permission: 'manage_pages' },
  { label: 'Customers & Leads', href: '/admin/customers', icon: IoPersonOutline, permission: 'manage_customers' },
  { label: 'Coupons', href: '/admin/coupons', icon: IoGiftOutline, permission: 'manage_coupons' },
  { label: 'Blocked dates', href: '/admin/availability', icon: IoCalendarOutline, permission: 'manage_availability' },
  { label: 'Pages', href: '/admin/pages', icon: IoDocumentTextOutline, permission: 'manage_pages' },
  { label: 'Blog', href: '/admin/blog', icon: IoBookOutline, permission: 'manage_pages' },
  { label: 'Home gallery', href: '/admin/home-gallery', icon: IoGridOutline, permission: 'manage_pages' },
  { label: 'Hero sliders', href: '/admin/pages/hero-sliders', icon: IoImagesOutline, permission: 'manage_pages' },
  { label: 'Festival schedule', href: '/admin/pages/festival-schedule', icon: IoCalendarOutline, permission: 'manage_pages' },
  { label: 'Menu', href: '/admin/menu', icon: IoMenuOutline, permission: 'manage_pages' },
  { label: 'Staff', href: '/admin/staff', icon: IoPeopleOutline, permission: 'manage_staff' },
  {
    group: true,
    label: 'Rental Management',
    icon: IoShirtSharp,
    children: [
      { label: 'Outward', href: '/admin/rental/outward', icon: IoArrowUpOutline, permission: 'manage_rental' },
      { label: 'Inward', href: '/admin/rental/inward', icon: IoArrowDownOutline, permission: 'manage_rental' },
      { label: 'Laundry', href: '/admin/rental/laundry', icon: IoShirtSharp, permission: 'manage_rental' },
      { label: 'Damaged', href: '/admin/rental/damaged', icon: IoWarningOutline, permission: 'manage_rental' },
      { label: 'Kanban', href: '/admin/rental/kanban', icon: IoGridOutline, permission: 'manage_rental' },
      { label: 'Notifications', href: '/admin/notifications', icon: IoNotificationsOutline, permission: null },
    ],
  },
  {
    group: true,
    label: 'System',
    icon: IoServerOutline,
    children: [
      { label: 'Drive sync', href: '/admin/sync', icon: IoCloudUploadOutline, permission: 'drive_sync' },
      { label: 'CSV sync', href: '/admin/sync/csv', icon: IoDocumentTextOutline, permission: 'drive_sync' },
      { label: 'Firebase Auth', href: '/admin/firebase', icon: IoFingerPrintOutline, permission: null },
      { label: 'Roles', href: '/admin/roles', icon: IoKeyOutline, permission: 'manage_roles' },
      { label: 'Activity log', href: '/admin/activity', icon: IoListOutline, permission: 'view_activity' },
      { label: 'Account', href: '/admin/account', icon: IoPersonCircleOutline, permission: null },
    ],
  },
];

export default verticalMenuData;
